import React, { useState } from "react";
import { Pagination, OverlayTrigger, Tooltip, Col } from "react-bootstrap";
import Select from "react-select";
import { components } from "react-select";
import CreatableSelect from 'react-select/creatable';
import AsyncSelect from 'react-select/async';

// css
import styles from "./common.module.scss";
import { useField, useFormikContext } from "formik";
import { isEmpty } from "lodash";
import ConfirmationPop from "components/Modals/ConfirmationPop";
import { Link } from "react-router-dom";

const selectCustomStyles = {
  control: (provided, state) => ({
    ...provided,
    backgroundColor: "#c4c4c433", // Change the background color of the control
    borderColor: state.isFocused ? "#c4c4c433" : "#c4c4c433", // Change border color on focus
    boxShadow: state.isFocused ? "0 0 0 1px #c4c4c433" : null, // Optional: Change shadow on focus
    borderRadius: "10px",
    // minHeight: "55px",
  }),

  menu: (provided) => ({
    ...provided,
    fontFamily: "proxima nova",
    zIndex: 99999
  }),
  option: (provided, state) => ({
    ...provided,
    // backgroundColor: state.isSelected
    //   ? "#007BFF"
    //   : state.isFocused
    //   ? "#e2e2e2"
    //   : "#f0f0f0",
    color: state.isSelected ? "#000" : "#000", // Change text color based on selection
    borderBottom: "1px solid #ddd",
    "&:hover": {
      // backgroundColor: "#007BFF",
      color: "#000", // Change text color on hover
    },
  }),
};

const customStyleForFilterSelect = {
  ...selectCustomStyles,
  control: (provided, state) => ({
    ...provided,
    backgroundColor: "#c4c4c433", // Change the background color of the control
    borderColor: state.isFocused ? "#c4c4c433" : "#c4c4c433", // Change border color on focus
    boxShadow: state.isFocused ? "0 0 0 1px #c4c4c433" : null, // Optional: Change shadow on focus
    borderRadius: "10px",
    minWidth: "150px"
  }),
};

const SelectDropdownIndicator = (props) => {
  return (
    <components.DropdownIndicator {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="14"
        height="8"
        viewBox="0 0 14 8"
        fill="none"
      >
        <path
          d="M6.99995 7.4521L0.0273438 0.479492H13.9726L6.99995 7.4521Z"
          fill="#1C1B1F"
        />
      </svg>
    </components.DropdownIndicator>
  );
};

export const CstmPagination = ({
  activePage = 1,
  handlePageChange,
  totalPages = 0,
  maxPagesToShow = 5,
  className
}) => {

  const renderPaginationItems = () => {
    let items = [];

    const startPage = Math.max(1, activePage - 2); // Start two pages before the active page
    const endPage = Math.min(totalPages, activePage + 2); // End two pages after the active page

    // Add first page
    if (startPage > 1) {
      items.push(
        <Pagination.Item key={1} active={1 === activePage} onClick={() => handlePageChange(1)}>
          1
        </Pagination.Item>
      );

      // Add ellipsis after the first page if needed
      if (startPage > 2) {
        items.push(<Pagination.Ellipsis key="start-ellipsis" disabled />);
      }
    }

    // Add pages around the active page
    for (let number = startPage; number <= endPage; number++) {
      items.push(
        <Pagination.Item
          key={number}
          active={number === activePage}
          onClick={() => handlePageChange(number)}
        >
          {number}
        </Pagination.Item>
      );
    }

    // Add last page
    if (endPage < totalPages) {
      // Add ellipsis before the last page if needed
      if (endPage < totalPages - 1) {
        items.push(<Pagination.Ellipsis key="end-ellipsis" disabled />);
      }

      items.push(
        <Pagination.Item
          key={totalPages}
          active={totalPages === activePage}
          onClick={() => handlePageChange(totalPages)}
        >
          {totalPages}
        </Pagination.Item>
      );
    }

    return items;
  };

  return (
    <div
      className={`${styles.cstmPagination} ${className && className} cstmPagination d-flex align-items-center flex-wrap justify-content-end gap-10`}
    >
      <div className="right d-flex align-items-center gap-10">
        {/* <p className="m-0 fw-sbold text-dark">1-2 of items</p> */}
        <Pagination>
          <Pagination.Prev
            onClick={() => handlePageChange(Math.max(activePage - 1, 1))}
            disabled={activePage === 1 || (totalPages <= 0)}
          />
          {renderPaginationItems()}
          <Pagination.Next
            onClick={() => handlePageChange(Math.min(activePage + 1, totalPages))}
            disabled={activePage === totalPages || (totalPages <= 0)}
          />
        </Pagination>
      </div>
    </div>
  );
};


export const Rating = ({ size }) => {
  return (
    <>
      <ul
        className={`${styles.rating} list-unstyled ps-0 mb-0 d-flex align-items-center`}
      >
        <li className="">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 18 18"
            fill="none"
          >
            <g clip-path="url(#clip0_22_5548)">
              <path
                d="M9.44071 14.5436C9.16931 14.3792 8.829 14.3792 8.55761 14.5437L4.39532 17.0665C3.75017 17.4575 2.95263 16.8789 3.12406 16.1443L4.22755 11.4153C4.29924 11.1081 4.19529 10.7864 3.95739 10.5792L0.293637 7.38862C-0.273874 6.8944 0.031211 5.96092 0.781053 5.89724L5.60934 5.48723C5.92375 5.46053 6.19766 5.26223 6.3212 4.97188L8.21605 0.518403C8.51015 -0.172801 9.48985 -0.172801 9.78395 0.518404L11.6788 4.97188C11.8023 5.26224 12.0762 5.46053 12.3907 5.48723L17.2189 5.89724C17.9688 5.96092 18.2739 6.8944 17.7064 7.38862L14.0426 10.5792C13.8047 10.7864 13.7008 11.1081 13.7725 11.4153L14.876 16.1446C15.0474 16.8792 14.25 17.4578 13.6048 17.0668L9.44071 14.5436Z"
                fill="#FFC500"
              />
            </g>
            <defs>
              <clipPath id="clip0_22_5548">
                <rect width="18" height="17.25" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </li>
        <li className="">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 18 18"
            fill="none"
          >
            <g clip-path="url(#clip0_22_5548)">
              <path
                d="M9.44071 14.5436C9.16931 14.3792 8.829 14.3792 8.55761 14.5437L4.39532 17.0665C3.75017 17.4575 2.95263 16.8789 3.12406 16.1443L4.22755 11.4153C4.29924 11.1081 4.19529 10.7864 3.95739 10.5792L0.293637 7.38862C-0.273874 6.8944 0.031211 5.96092 0.781053 5.89724L5.60934 5.48723C5.92375 5.46053 6.19766 5.26223 6.3212 4.97188L8.21605 0.518403C8.51015 -0.172801 9.48985 -0.172801 9.78395 0.518404L11.6788 4.97188C11.8023 5.26224 12.0762 5.46053 12.3907 5.48723L17.2189 5.89724C17.9688 5.96092 18.2739 6.8944 17.7064 7.38862L14.0426 10.5792C13.8047 10.7864 13.7008 11.1081 13.7725 11.4153L14.876 16.1446C15.0474 16.8792 14.25 17.4578 13.6048 17.0668L9.44071 14.5436Z"
                fill="#FFC500"
              />
            </g>
            <defs>
              <clipPath id="clip0_22_5548">
                <rect width="18" height="17.25" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </li>
        <li className="">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 18 18"
            fill="none"
          >
            <g clip-path="url(#clip0_22_5548)">
              <path
                d="M9.44071 14.5436C9.16931 14.3792 8.829 14.3792 8.55761 14.5437L4.39532 17.0665C3.75017 17.4575 2.95263 16.8789 3.12406 16.1443L4.22755 11.4153C4.29924 11.1081 4.19529 10.7864 3.95739 10.5792L0.293637 7.38862C-0.273874 6.8944 0.031211 5.96092 0.781053 5.89724L5.60934 5.48723C5.92375 5.46053 6.19766 5.26223 6.3212 4.97188L8.21605 0.518403C8.51015 -0.172801 9.48985 -0.172801 9.78395 0.518404L11.6788 4.97188C11.8023 5.26224 12.0762 5.46053 12.3907 5.48723L17.2189 5.89724C17.9688 5.96092 18.2739 6.8944 17.7064 7.38862L14.0426 10.5792C13.8047 10.7864 13.7008 11.1081 13.7725 11.4153L14.876 16.1446C15.0474 16.8792 14.25 17.4578 13.6048 17.0668L9.44071 14.5436Z"
                fill="#FFC500"
              />
            </g>
            <defs>
              <clipPath id="clip0_22_5548">
                <rect width="18" height="17.25" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </li>
        <li className="">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 18 18"
            fill="none"
          >
            <g clip-path="url(#clip0_22_5554)">
              <path
                d="M9.44071 14.5436C9.16931 14.3792 8.829 14.3792 8.55761 14.5437L4.39532 17.0665C3.75017 17.4575 2.95263 16.8789 3.12406 16.1443L4.22755 11.4153C4.29924 11.1081 4.19529 10.7864 3.95739 10.5792L0.293637 7.38862C-0.273874 6.8944 0.031211 5.96092 0.781053 5.89724L5.60934 5.48723C5.92375 5.46053 6.19766 5.26223 6.3212 4.97188L8.21605 0.518403C8.51015 -0.172801 9.48985 -0.172801 9.78395 0.518404L11.6788 4.97188C11.8023 5.26224 12.0762 5.46053 12.3907 5.48723L17.2189 5.89724C17.9688 5.96092 18.2739 6.8944 17.7064 7.38862L14.0426 10.5792C13.8047 10.7864 13.7008 11.1081 13.7725 11.4153L14.876 16.1446C15.0474 16.8792 14.25 17.4578 13.6048 17.0668L9.44071 14.5436Z"
                fill="#E0E8F1"
              />
              <mask
                id="mask0_22_5554"
                style={{ maskType: "alpha" }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="18"
                height="18"
              >
                <path
                  d="M9.44071 14.5436C9.16931 14.3792 8.829 14.3792 8.55761 14.5437L4.39532 17.0665C3.75017 17.4575 2.95263 16.8789 3.12406 16.1443L4.22755 11.4153C4.29924 11.1081 4.19529 10.7864 3.95739 10.5792L0.293637 7.38862C-0.273874 6.8944 0.031211 5.96092 0.781053 5.89724L5.60934 5.48723C5.92375 5.46053 6.19766 5.26223 6.3212 4.97188L8.21605 0.518403C8.51015 -0.172801 9.48985 -0.172801 9.78395 0.518404L11.6788 4.97188C11.8023 5.26224 12.0762 5.46053 12.3907 5.48723L17.2189 5.89724C17.9688 5.96092 18.2739 6.8944 17.7064 7.38862L14.0426 10.5792C13.8047 10.7864 13.7008 11.1081 13.7725 11.4153L14.876 16.1446C15.0474 16.8792 14.25 17.4578 13.6048 17.0668L9.44071 14.5436Z"
                  fill="#E0E8F1"
                />
              </mask>
              <g mask="url(#mask0_22_5554)">
                <rect width="9" height="17.1907" fill="#FFC500" />
              </g>
            </g>
            <defs>
              <clipPath id="clip0_22_5554">
                <rect width="18" height="17.25" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </li>
        <li className="">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 18 18"
            fill="none"
          >
            <g clip-path="url(#clip0_22_5548)">
              <path
                d="M9.44071 14.5436C9.16931 14.3792 8.829 14.3792 8.55761 14.5437L4.39532 17.0665C3.75017 17.4575 2.95263 16.8789 3.12406 16.1443L4.22755 11.4153C4.29924 11.1081 4.19529 10.7864 3.95739 10.5792L0.293637 7.38862C-0.273874 6.8944 0.031211 5.96092 0.781053 5.89724L5.60934 5.48723C5.92375 5.46053 6.19766 5.26223 6.3212 4.97188L8.21605 0.518403C8.51015 -0.172801 9.48985 -0.172801 9.78395 0.518404L11.6788 4.97188C11.8023 5.26224 12.0762 5.46053 12.3907 5.48723L17.2189 5.89724C17.9688 5.96092 18.2739 6.8944 17.7064 7.38862L14.0426 10.5792C13.8047 10.7864 13.7008 11.1081 13.7725 11.4153L14.876 16.1446C15.0474 16.8792 14.25 17.4578 13.6048 17.0668L9.44071 14.5436Z"
                fill="#E0E8F1"
              />
            </g>
            <defs>
              <clipPath id="clip0_22_5548">
                <rect width="18" height="17.25" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </li>
      </ul>
    </>
  );
};

export const CommonSelect = ({
  option,
  placeholder,
  cstmOption = undefined,
  name,
  handleBlur,
  onChange,
  creatable,
  defaultValue,
  isLoading,
  isFilter,
  onInputChange,
  handleChangeCustom,
  isFilterV2,
  ...props
}) => {
  const { setFieldValue, values, errors, touched } = useFormikContext() || {};
  const [field, meta] = name ? useField(name) : [];

  const handleFieldChange = (selected) => {
    name &&
      typeof setFieldValue === "function" &&
      setFieldValue(name, selected);

    typeof onChange === "function" && onChange(selected);
    typeof handleChangeCustom === "function" && handleChangeCustom(selected);
  }

  const IndicatorSeparator = () => {
    return null;
  };

  const options = option;
  const optionProps = { SelectDropdownIndicator, IndicatorSeparator };
  if (cstmOption) {
    optionProps.Option = cstmOption;
  }

  const selectedValue = name
    ? field?.value || null
    : options?.find(o => o.value === defaultValue?.value) || null;

  const renderComponent = () => {
    return (
      creatable ? (
        <CreatableSelect

          // isClearable 
          placeholder={isLoading ? "Loading..." : placeholder}
          components={optionProps}
          classNamePrefix={"khan"}
          options={options}
          // styles={isFilter ? customStyleForFilterSelect : selectCustomStyles}
          styles={isFilterV2 ? selectCustomStyles : isFilter ? customStyleForFilterSelect : selectCustomStyles}
          onChange={handleFieldChange}
          onBlur={handleBlur}
          value={(field?.value || null)}
          defaultValue={defaultValue}
          onInputChange={onInputChange}
          isLoading={isLoading}

          {...props}

        />
      ) : (
        <Select
          placeholder={isLoading ? "Loading..." : placeholder}
          components={optionProps}
          // menuIsOpen
          classNamePrefix={"forteen khan"}
          options={options}
          // styles={isFilter ? customStyleForFilterSelect : selectCustomStyles}
          styles={isFilterV2 ? selectCustomStyles : isFilter ? customStyleForFilterSelect : selectCustomStyles}
          onChange={handleFieldChange}
          onBlur={handleBlur}
          value={selectedValue}
          defaultValue={defaultValue}
          onInputChange={onInputChange}
          isLoading={isLoading}
          {...props}
          name={name}
        // {...field}
        />
      )
    )
  }
  return (
    <>
      {renderComponent()}
      {(meta?.touched && meta?.error) ? (
        <div className="error">{typeof meta.error === "string" ? meta.error : meta.error?.value}</div>
      ) : null}
    </>
  );
};



export const DisciplineField = ({ name, options, onChange }) => {
  const [field, meta, helpers] = useField(name);

  const handleClick = (item) => {
    const value = {
      label: item.name,
      value: item.id,
    };

    helpers.setValue(value);
    helpers.setTouched(true); // ✅ IMPORTANT
    onChange?.(value, item);
  };

  return (
    <>
      <div className="d-flex gap-2 flex-wrap">
        {options?.map((item) => (
          <button
            key={item.id}
            type="button"
            className={`btn px-3 py-1 ${field.value?.value === item.id
              ? "btn-primary"
              : "btn-outline-secondary"
              }`}
            onClick={() => handleClick(item)}
          >
            {item.name}
          </button>
        ))}
      </div>

      {/* ✅ ERROR DISPLAY */}
      {(meta?.touched && meta?.error) ? (
        <div className="error">{typeof meta.error === "string" ? meta.error : meta.error?.value}</div>
      ) : null}
    </>
  );
};



export const CustomAsyncSelect = ({
  option,
  placeholder,
  cstmOption = undefined,
  name,
  handleBlur,
  onChange,
  value,
  defaultValue,
  loadOptions,
  isFilter,
  defaultOptions
}) => {
  const { setFieldValue, values, errors, touched } = useFormikContext() || {};
  const [field, meta] = name ? useField(name) : [];

  const handleFieldChange = (selected) => {
    name &&
      typeof setFieldValue === "function" &&
      setFieldValue(name, selected);

    typeof onChange === "function" && onChange(selected);
  }

  const IndicatorSeparator = () => {
    return null;
  };

  const options = option;
  const optionProps = { SelectDropdownIndicator, IndicatorSeparator };
  if (cstmOption) {
    optionProps.Option = cstmOption;
  }

  return (
    <>
      <AsyncSelect
        cacheOptions
        loadOptions={loadOptions}
        placeholder={placeholder}
        components={optionProps}
        classNamePrefix={"khan"}
        styles={isFilter ? customStyleForFilterSelect : selectCustomStyles}
        onChange={handleFieldChange}
        onBlur={handleBlur}
        value={(field?.value || value || null)}
        defaultValue={defaultValue}
        defaultOptions={defaultOptions}
        {...field}
      />
      {(meta?.touched && meta?.error) ? (
        <div className="error">{typeof meta?.error === "string" ? meta?.error : meta?.error?.value}</div>
      ) : null}
    </>
  );
};

export const CommonMultiSelect = ({
  option,
  placeholder,
  cstmOption = undefined,
  name,
  handleBlur,
  onChange,
  creatable,
  defaultValue,
  isLoading,
  onInputChange,
  onRemove,
  removeConfirmationType,
  isDisabled
}) => {
  const { setFieldValue, values, errors, touched } = useFormikContext() || {};
  const [field, meta] = useField(name) || {};
  const [showModal, setShowModal] = useState(false);
  const [pendingClear, setPendingClear] = useState(false);
  const [removeValue, setRemoveValue] = useState(null)

  const handleFieldChange = (selected, action) => {

    // Case 1: Clicked clear all (cross icon)
    if (action?.action === "remove-value" && removeConfirmationType) {
      setRemoveValue(action?.removedValue)
      setShowModal(true); // Show confirmation modal
      setPendingClear(true); // Store intent to clear
      return; // Stop normal execution
    }

    // Normal selection update
    if (name && typeof setFieldValue === "function") {
      setFieldValue(name, selected);
    }
    if (typeof onChange === "function") {
      onChange(selected);
    }
  };

  // Then in your modal confirmation
  const confirmClear = () => {
    if (pendingClear && name && typeof setFieldValue === "function" && removeValue) {
      const data = field?.value?.filter((item) => item?.value != removeValue?.value)
      setFieldValue(name, data || []);
      if (typeof onChange === "function") {
        onChange([]);
      }
    }
    setPendingClear(false);
    setShowModal(false);
  };

  const IndicatorSeparator = () => {
    return null;
  };

  const options = option;
  const optionProps = { SelectDropdownIndicator, IndicatorSeparator };
  if (cstmOption) {
    optionProps.Option = cstmOption;
  }

  const renderComponent = () => {
    return (
      <>
        <Select
          isMulti
          placeholder={isLoading ? "Loading..." : placeholder}
          components={optionProps}
          options={options}
          styles={selectCustomStyles}
          onChange={handleFieldChange}
          onBlur={handleBlur}
          value={(field?.value || null)}
          defaultValue={defaultValue}
          closeMenuOnSelect={false}
          onInputChange={onInputChange}
          isClearable={false}
          isDisabled={isDisabled}
          name={name}
        />
        {
          removeConfirmationType && <ConfirmationPop
            confirmation={showModal}
            setConfirmation={setShowModal}
            confirmHandler={confirmClear}
            type={removeConfirmationType}
          />
        }
      </>
    )
  }
  return (
    <>
      {renderComponent()}
      {(meta.touched && meta.error) ? (
        <div className="error">{typeof meta.error === "string" ? meta.error : meta.error?.value}</div>
      ) : null}
    </>
  );
};

export const RequiredFieldAstrick = () => {

  return <span className="required-astrick">*</span>
}

export const CommonCreateSelect = ({
  option,
  placeholder,
  name,
  handleBlur,
  onChange,
  creatable,
  defaultValue,
  isLoading,
  onInputChange,
  ...props
}) => {
  const { setFieldValue, values, errors, touched } = useFormikContext() || {};
  const [field, meta] = useField(name) || {};

  const handleFieldChange = (selected) => {
    name &&
      typeof setFieldValue === "function" &&
      setFieldValue(name, selected);

    typeof onChange === "function" && onChange(selected);
  }

  const IndicatorSeparator = () => {
    return null;
  };


  const DropdownIndicator = () => {
    return null;
  };

  const options = option;
  const optionProps = { DropdownIndicator, IndicatorSeparator };

  const renderComponent = () => {
    return (
      <CreatableSelect
        isValidNewOption={() => Boolean}
        placeholder={isLoading ? "Loading..." : placeholder}
        components={optionProps}
        classNamePrefix={"khan"}
        options={options}
        styles={selectCustomStyles}
        onChange={handleFieldChange}
        onBlur={handleBlur}
        value={(field?.value || null)}
        defaultValue={defaultValue}
        onInputChange={onInputChange}
        isLoading={isLoading}
        {...props}
      />
    )
  }
  return (
    <>
      {renderComponent()}
      {(meta.touched && meta.error) ? (
        <div className="error">{typeof meta.error === "string" ? meta.error : meta.error?.value}</div>
      ) : null}
    </>
  );
};

export const CommonToolTip = ({ component, text }) => {

  return (
    <div>
      <OverlayTrigger
        trigger={['hover', 'focus']}
        placement="top"
        overlay={
          <Tooltip style={{ position: "fixed" }}>
            {text}
          </Tooltip>
        }
      >
        {component}
      </OverlayTrigger>
    </div>
  )
}

export const NoRecordFound = ({ space, message = 'No Record Found' }) => {

  return (
    // <div className={`w-100 parents-detail-wrapper d-flex align-items-center justify-content-center commonBtn mt-2 borderedBtn bg-transparent ${space && 'px-2'}`}>
    <div className={`w-100 parents-detail-wrapper d-flex align-items-center justify-content-center py-2 mt-2 borderedBtn bg-transparent ${space && 'px-2'}`}>

      {message}
    </div>
  )
}

export const ReportsNoRecordMessage = ({ msg = 'No Record Found', className = "", ...props }) => {
  return <div {...props} className={`py-2 mt-5 d-flex align-items-center justify-content-center w-100 ${"guardian-not-assigned-wrapper"} ${className}`}>
    {msg}
  </div>
}

export const Breadcrumbs = ({ themeBlueV2, items = [] }) => {
  return (
    <Col lg="12">
      <div className="pageHead proxima d-flex align-items-center justify-content-between flex-wrap gap-10">
        <div className="left">
          <ul className="list-unstyled gap-2 ps-0 mb-0 d-flex align-items-center">
            {items.map((item, index) => (
              <React.Fragment key={index}>
                <li>
                  {item.path ? (
                    <Link
                      to={item.path}
                      className={themeBlueV2 ? 'themeBlueV2' : "themeBlue"}
                      style={{ textDecoration: "underline" }}
                    >
                      {item.label}
                    </Link>
                  ) : (
                    <h5 style={{ fontSize: "14px" }} className="m-0">{item.label}</h5>
                  )}
                </li>
                {index < items.length - 1 && <span>/</span>}
              </React.Fragment>
            ))}
          </ul>
        </div>
      </div>
    </Col>
  );
};

export const NoRecordFoundV2 = ({ message = "No Record Found", style = {}, className = "no-record-v2" }) => {
  return (
    <div style={{ ...style }} className={`${className} classroom-no-reports mt-2 w-100`}>
      <p>{message}</p>
    </div>
  )
}